
import { ref, defineComponent } from "vue-demi";

interface ITab {
  label: string;
  value: string;
}

export default defineComponent({
  name: "Tabs",

  emits: ["set-tab"],

  setup(_, { emit }) {
    const tabs = [
      {
        label: "All",
        value: "all",
      },
      {
        label: "Platform",
        value: "platform",
      },
      {
        label: "Home Office",
        value: "home_office",
      },
    ];

    const selectedTab = ref(tabs[0]);

    function onTabSelect(tab: ITab) {
      selectedTab.value = tab;

      emit("set-tab", tab.value);
    }

    return {
      tabs,
      selectedTab,
      onTabSelect,
    };
  },
});
